/* WordOn Company — predictive search */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.querySelector('[data-predictive-search-form]');
    if (!form) return;
    var input = form.querySelector('input[type="search"]');
    var resultsWrap = document.querySelector('[data-search-results]');
    var timer;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var query = input.value.trim();
      if (query.length < 2) {
        resultsWrap.innerHTML = '';
        return;
      }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              resultsWrap.innerHTML = '<p style="padding:12px 0;opacity:.7">No results for "' + query + '"</p>';
              return;
            }
            resultsWrap.innerHTML = products
              .map(function (p) {
                return (
                  '<a class="search-result" href="' + p.url + '">' +
                  '<img src="' + (p.featured_image ? p.featured_image.url : '') + '" alt="' + p.title + '">' +
                  '<span><strong style="display:block;font-family:var(--font-heading);text-transform:uppercase;font-size:.9rem">' + p.title + '</strong>' +
                  '<span style="font-size:.85rem;opacity:.75">' + p.price + '</span></span>' +
                  '</a>'
                );
              })
              .join('');
          })
          .catch(function () {});
      }, 250);
    });

    form.addEventListener('submit', function (e) {
      if (!input.value.trim()) e.preventDefault();
    });
  });
})();
